<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto form-inline">
                <form v-on:keypress.enter.prevent="searchProductReport"
                      class="my-2 my-lg-0">
                    <input
                        class="form-control mr-sm-2"
                        type="search"
                        placeholder="รหัสสินค้า"
                        v-model="search.code"
                        aria-label="Search"/>
                    <date-picker
                        v-model="search.date"
                        type="date"
                        :format="changeFormat"
                        :lang="lang"
                        placeholder="วันที่อัพเดต">
                    </date-picker>
                    <multiselect
                        class="form-control select"
                        v-model="search.machine"
                        placeholder="เครื่องผลิต"
                        :options="optionMachine"
                        label="name"
                        :show-labels="false"
                        track-by="id">
                    </multiselect>
                    <button
                        class="btn btn-success my-2 my-sm-0"
                        type="button"
                        @click="searchProductReport">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp
                    <button @click="showPercentMachineModal"
                            v-if="canInventoryReportsProductsUpdate || canInventoryView"
                            class="btn btn-default next my-2 my-sm-0"
                            type="button">
                        <icon name="cogs"></icon>
                        ตั้งค่าเปอร์เซ็นที่ยอมรับได้
                    </button>
                    &nbsp;
                    <template v-if="canInventoryReportsProductsOrder || canInventoryView">
                        <router-link to="production-report-information">
                            <button
                                class="btn btn-warning my-2 my-sm-0"
                                type="button">
                                <icon name="plus"></icon>
                                ผลิตสินค้า
                            </button>
                        </router-link>
                    </template>
                </form>
                &nbsp
                <button class="btn btn-primary"
                        v-if="product_report.length > 0"
                        @click="showModalPrint">
                    <icon name="file-download"></icon>
                    พิมพ์รายงาน
                </button>
            </div>
        </nav>
        <div style="padding-left: 10px">
            <icon name="circle" style="color: #EEAA16;"></icon>
            <label>สินค้า ผลิตได้น้อยกว่ามาตรฐาน</label> &nbsp;
            <icon name="circle" style="color: deepskyblue;"></icon>
            <label>เวลา เกินกว่ามาตรฐาน</label> &nbsp;
            <icon name="circle" style="color: palevioletred;;"></icon>
            <label>สินค้า & เวลาที่ผลิตไม่ได้มาตรฐาน</label> &nbsp;
        </div>
        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <template v-if="canInventoryReportsProductsDetailView || canSaleView || canInventoryView">
                        <th scope="col">เครื่อง</th>
                        <th scope="col">ชีท</th>
                    </template>
                    <th scope="col">รหัสสินค้า</th>
                    <th scope="col">วันที่เริ่มผลิต</th>
                    <th scope="col">เวลาที่เริ่มผลิต</th>
                    <th scope="col">กะ</th>
                    <!--                    <th scope="col">กลุ่ม</th>-->
                    <template v-if="canInventoryReportsProductsDetailView || canSaleView || canInventoryView">
                        <th scope="col">วันที่อัพเดต</th>
                        <th scope="col">สถานะต่อเนื่อง</th>
                        <th scope="col">ผู้สั่งผลิต</th>
                        <th scope="col">จำนวนขึ้นรูปที่คาดได้</th>
                        <th scope="col">เวลาที่คาดได้ที่ใช้ในการผลิต</th>
                        <th scope="col">หมายเหตุ</th>
                        <th scope="col" v-if="canInventoryReportsProductsUpdate || canInventoryView">สรุปการขึ้นรูป</th>
                        <th scope="col">ปัญหาการผลิต</th>
                        <th scope="col" v-if="canInventoryReportsProductsUpdate || canInventoryView">เพิ่มปัญหาการผลิต
                        </th>
                        <template v-if="canInventoryReportsProductsUpdate || canInventoryView">
                            <th scope="col">แก้ไข</th>
                        </template>
                    </template>
                </tr>
                </thead>
                <tbody>
                <template v-for="data in product_report">
                    <tr :class="{'quantity-percent' : data.status_percent == 1 , 'time-percent' : data.status_percent == 2, 'time-quantity' : data.status_percent == 3}">
                        <template v-if="canInventoryReportsProductsDetailView || canSaleView || canInventoryView">
                            <td>
                                <template v-if="data.machine">
                                    {{ data.machine.name }}
                                </template>
                                <template v-else>
                                    <p>ไม่ระบุ</p>
                                </template>
                            </td>
                            <td>
                                <template v-if="data.sheet">
                                    {{ data.sheet.name }}
                                </template>
                                <template v-else>
                                    <p>ไม่ระบุ</p>
                                </template>
                            </td>
                        </template>

                        <td>
                            <template v-if="data.products">
                                {{ data.products.sku }}
                            </template>
                            <template v-else>
                                <p>ไม่ระบุ</p>
                            </template>
                        </td>
                        <td>
                            <template v-if="data.start_date">
                                {{ data.start_date | moment("DD/MM/YYYY") }}
                            </template>
                            <template v-else>ไม่ระบุ</template>
                        </td>
                        <td>
                            <template v-if="data.start_time">
                                {{ data.start_time }}
                            </template>
                            <template v-else>ไม่ระบุ</template>
                        </td>
                        <td>
                            <template v-if="data.shift_start">
                                {{ data.shift_start.name }}
                            </template>
                            <template v-else>
                                <p>ไม่ระบุ</p>
                            </template>
                        </td>
                        <!--                        <td>-->
                        <!--                            <template v-if="data.group_id">-->
                        <!--                                {{data.group_name}}-->
                        <!--                            </template>-->
                        <!--                            <template v-else>-</template>-->
                        <!--                        </td>-->
                        <template v-if="canInventoryReportsProductsDetailView || canSaleView || canInventoryView">
                            <td>{{ data.updated_at | moment("DD/MM/YYYY , HH:mm:ss") }}</td>
                            <td>
                                <template v-if="data.work_start == 3">
                                    <img src="@/assets/check.png" width="20px"/>
                                </template>
                                <template v-else>
                                    <img src="@/assets/not.png" width="15px"/>
                                </template>
                            </td>
                            <td>
                                {{ data.user }}
                            </td>
                            <td>{{ data.quantity_calculate | amount }} (แพ็ค)</td>
                            <td>{{ data.time_calculate | currency }} (ชั่วโมง)</td>
                            <td>{{ data.reason }}</td>
                            <td v-if="canInventoryReportsProductsUpdate || canInventoryView">
                                <b-button @click="showReceiveSheetModal(data.id)"
                                          class="btn btn-success">
                                    <icon name="plus"></icon>
                                </b-button>
                            </td>
                            <td>
                                {{ data.problem }}
                            </td>
                            <td v-if="canInventoryReportsProductsUpdate || canInventoryView">
                                <b-button
                                    class="btn btn-success"
                                    @click="showModalProblem(data.id)">
                                    <icon name="plus"></icon>
                                </b-button>
                            </td>
                            <template v-if="canInventoryReportsProductsUpdate || canInventoryView">
                                <td>
                                    <a @click="showProductReport(data.id)">
                                        <icon name="pencil-alt"></icon>
                                    </a>
                                </td>
                            </template>
                        </template>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
        <br/>
        <div v-if="product_report.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getSheetImportPage">
            </vue-pagination>
        </div>
        <!--b-modal report_print--->
        <b-modal hide-header hide-footer ref="report_print">
            <div>
                <br>
                <h4 class="text-center">กรุณาเลือกกะ/วันที่ ที่ต้องการพิมพ์รายงาน</h4>
                <br/>
                <div class="row">
                    <b-col class="col-sm-4 text-right">กรุณาเลือกวันที่</b-col>
                    <b-col class="col-sm-6">
                        <date-picker
                            v-model="report.date"
                            type="date"
                            class="w-100"
                            :format="changeFormat"
                            :lang="lang"
                            placeholder="วันที่อัพเดต" confirm>
                        </date-picker>
                    </b-col>
                </div>
                <br/>
                <div class="row">
                    <b-col class="col-sm-4 text-right">กรุณาเลือกกะ</b-col>
                    <b-col class="col-sm-6">
                        <b-form-select
                            v-model="report.shift"
                            class="w-100"
                            :options="optionShip">
                        </b-form-select>
                    </b-col>
                </div>
                <br/>
                <b-row>
                    <div class="col text-center">
                        <button type="button"
                                @click="print(report)"
                                class="btn btn-primary">
                            <icon name="file-download" style="width: 25px"></icon>
                            พิมพ์
                        </button>
                        &nbsp&nbsp
                        <button type="button" class="btn btn-danger" @click="hideModalPrint">
                            <icon name="times" style="width: 25px"></icon>
                            ยกเลิก
                        </button>
                    </div>
                </b-row>
            </div>
        </b-modal>
        <!--b-modal report_problem--->
        <b-modal hide-header hide-footer ref="report_problem">
            <div style="padding: 0px 20px;text-align: center">
                <br>
                <h4 class="text-center">รายงานปัญหาการผลิต</h4>
                <br/>
                <div class="row">
                    <div class="col-sm-12">
                        <textarea
                            v-model="form.problem"
                            rows="5"
                            class="form-control"
                        ></textarea>
                    </div>
                </div>

                <br/>
                <button @click="saveProblemProductReport"
                        type="button"
                        class="btn btn-success">
                    <icon name="save" style="width: 25px"></icon>
                    บันทึก
                </button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="hideModalProblem">
                    <icon name="times" style="width: 25px"></icon>
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!---b-modal percent_machine--->
        <b-modal hide-header hide-footer ref="percent_machine">
            <h4 style="text-align: center">ค่าเปอร์เซ็นที่สามารถยอมรับได้</h4>
            <br/>
            <div class="row form-group">
                <label class="col-sm-4 text-right">จำนวนการขึ้นรูป</label>
                <div class="col-sm-6">
                    <input type="number" class="form-control" v-model="percent_machine.percent_quantity"/>
                </div>
                <label>%</label>
            </div>
            <div class="row form-group">
                <label class="col-sm-4 text-right">เวลาที่ใช้ในการขึ้นรูป</label>
                <div class="col-sm-6">
                    <input type="number" class="form-control" v-model="percent_machine.percent_time"/>
                </div>
                <label>%</label>
            </div>
            <div class="row">
                <div class="col text-center">
                    <button @click="savePercentMachine"
                            type="button"
                            class="btn btn-success">
                        <icon name="save" style="width: 25px"></icon>
                        บันทึก
                    </button>
                    &nbsp&nbsp
                    <button type="button"
                            @click="hidePercentMachineModal"
                            class="btn btn-outline-secondary">
                        <icon name="times" style="width: 25px"></icon>
                        ยกเลิก
                    </button>
                </div>
            </div>
        </b-modal>
        <!------b-modal receive_sheet--------->
        <b-modal hide-header hide-footer ref="receive_sheet">
            <h4 style="text-align: center">ค่าเปอร์เซ็นที่สามารถยอมรับได้</h4>
            <br/>
            <div class="row form-group">
                <label class="col-sm-4 text-right">นำชีทเข้า</label>
                <div class="col-sm-6">
                    <input type="number" class="form-control" v-model="form.receive_sheet"/>
                </div>
                <label>ม้วน</label>
            </div>
            <div class="row form-group">
                <label class="col-sm-4 text-right">จำนวนที่ขึ้นรูปที่ผลิตได้จริง</label>
                <div class="col-sm-6">
                    <input type="number" class="form-control" v-model="form.product_real"/>
                </div>
            </div>
            <div class="row form-group">
                <label class="col-sm-4 text-right">วันที่สิ้นสุดการผลิต</label>
                <div class="col-sm-6">
                    <date-picker
                        v-model="form.end_date"
                        type="date"
                        :format="changeFormat"
                        :lang="lang"
                        placeholder="วันที่สิ้นสุดการผลิต" confirm>
                    </date-picker>
                </div>
            </div>
            <div class="row form-group">
                <label class="col-sm-4 text-right">เวลาสิ้นสุดการผลิต</label>
                <div class="col-sm-6">
                    <input type="time" class="form-control" v-model="form.end_time"/>
                </div>
            </div>
            <div class="row">
                <div class="col text-center">
                    <button @click="saveReceiveSheet"
                            type="button"
                            class="btn btn-success">
                        <icon name="save" style="width: 25px"></icon>
                        บันทึก
                    </button>
                    &nbsp&nbsp
                    <button type="button"
                            @click="hideReceiveSheetModal"
                            class="btn btn-outline-secondary">
                        <icon name="times" style="width: 25px"></icon>
                        ยกเลิก
                    </button>
                </div>
            </div>
        </b-modal>
        <br/>
        <!--<pre class="alert-primary">{{percent_machine}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";
import {domain} from "../../../util/Constants";
import VuePagination from "../../Pagination";
import DatePicker from 'vue2-datepicker'
import moment from "moment";

import {
    canInventoryReportsProductsDetailView,
    canInventoryReportsProductsOrder,
    canInventoryReportsProductsUpdate,
    canInventoryView,
    canSaleView
} from "../../../util/Permissions"

export default {
    name: "production-report",
    components: {
        VuePagination,
        Multiselect,
        DatePicker
    },
    created() {
        this.getMachinePercent();
        this.domain = domain + '/product-report-pdf';
        this.$store.dispatch("ReportProduct/get");
        this.$store.dispatch("Products/setProducts");
        this.$store.dispatch("Machine/get");
        this.$store.dispatch("ReportProduct/clearSearch");
    },
    computed: {
        canInventoryReportsProductsDetailView,
        canInventoryReportsProductsOrder,
        canInventoryReportsProductsUpdate,
        canInventoryView,
        canSaleView,
        ...mapState({
            product_report: state => {
                return state.ReportProduct.table;
            },
            optionProduct: state => {
                return state.Products.data;
            },
            optionMachine: state => {
                return state.Machine.data;
            },
            dataPaginate: state => {
                return state.ReportProduct.dataPaginate;
            },
            search: state => {
                return state.ReportProduct.search;
            },
            form: state => {
                return state.ReportProduct.Form;
            },
            percent_machine: state => {
                return state.ReportProduct.percent_machine;
            }
        })
    },
    data() {
        return {
            activeCloseDate: false,
            id: "",
            dateFormat: 'D/MM/YYYY',
            dateOne: '',
            report: {
                shift: "",
                date: "",
                problem: "",
            },
            optionShip: [
                {value: "", text: "กรุณาเลือกกะ"},
                {value: 1, text: "กลางวัน"},
                {value: 2, text: "กลางคืน"}
            ],
            domain: "",
            event_submit: false,
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        };
    },
    methods: {
        //Modal
        showModalPrint() {
            this.$refs.report_print.show();
        },
        hideModalPrint() {
            this.$refs.report_print.hide();
        },
        showModalProblem(id) {
            //console.log(this.id);
            this.$store.dispatch("ReportProduct/show", id).then(() => {
                this.$refs.report_problem.show();
            });
        },
        hideModalProblem() {
            this.$refs.report_problem.hide();
        },
        showPercentMachineModal() {
            this.getMachinePercent();
            this.$refs.percent_machine.show();
        },
        hidePercentMachineModal() {
            this.$refs.percent_machine.hide();
        },
        showReceiveSheetModal(id) {
            this.$store.dispatch("ReportProduct/show", id).then(() => {
                this.id = id;
                this.$refs.receive_sheet.show();
            });
        },
        hideReceiveSheetModal() {
            this.$refs.receive_sheet.hide();
        },

        //clear
        clearDate() {
            this.search.date = "";
        },
        //API
        showProductReport(id) {
            //console.log(this.id);
            this.$store.dispatch("ReportProduct/show", id).then(() => {
                this.$router.push({
                    name: "production-report-information",
                    params: {id}
                });
            });
        },
        searchProductReport() {
            let machine = "";
            if (!this.search.machine) {
                machine = ""
            } else {
                machine = this.search.machine.id;
            }
            //console.log(this.search);
            if (this.search.date) {
                this.search.date = moment(this.search.date).format("YYYY-MM-DD");
            } else {
                this.search.date = "";
            }
            this.$store.dispatch("ReportProduct/search", {
                code: this.search.code,
                date: this.search.date,
                machine: machine
            });
        },
        saveProblemProductReport() {
            if (!this.form.problem) {
                alert('กรุณากรอกปัญหาการผลิต')
            } else {
                //console.log(this.form.problem);
                this.$store.dispatch("ReportProduct/save", this.form.id).then(() => {
                    this.hideModalProblem();
                    this.$store.dispatch("ReportProduct/get");
                });
            }
        },
        saveReceiveSheet() {
            if (!this.form.receive_sheet) {
                alert("กรุณากรอกม้วนชีทที่ใช้ไป");
            } else if (!this.form.end_date) {
                alert("กรุณากรอกวันที่สิ้นสุดการผลิต")
            } else if (!this.form.end_time) {
                alert("กรุณากรอกเวลาสิ้นสุดการผลิต")
            } else {
                this.form.end_date = moment(this.form.end_date).format("YYYY-MM-DD");
                this.$store.dispatch("ReportProduct/save", this.id).then(() => {
                    this.$store.dispatch("ReportProduct/get");
                });
                this.hideReceiveSheetModal();
            }
        },
        goToProductReportList() {
            this.$router.push({
                name: "production-report"
            });
        },
        getSheetImportPage() {
            const page = this.dataPaginate.current_page;
            if (this.event_submit) {
                let machine = "";
                if (!this.search.machine) {
                    machine = ""
                } else {
                    machine = this.search.machine.id;
                }
                this.$store.dispatch("ReportProduct/search", {
                    code: this.search.code,
                    date: this.search.date,
                    machine: machine
                });
            } else {
                this.$store.dispatch('ReportProduct/get', page);
            }
        },
        print(report) {
            if (!report.shift) {
                alert("กรุณาเลือกกะ")
            } else if (!report.date) {
                alert("กรุณาเลือกวันที่")
            } else {
                const shift = report.shift;
                const date = moment(report.date).format("YYYY-MM-DD");
                window.open(this.domain + "/" + shift + "/" + date);
                this.hideModalPrint();
            }
        },
        //machine percent
        getMachinePercent() {
            this.$store.dispatch("ReportProduct/getMachinePercent");
        },
        savePercentMachine() {
            this.$store.dispatch("ReportProduct/saveMachinePercent", this.percent_machine.id).then(() => {
                this.$store.dispatch("ReportProduct/get");
            });
            this.hidePercentMachineModal();
        },
    }
};
</script>

<style scoped>
.select {
    border: 0;
}

.border-left-0 {
    border-left: 0;
}

.quantity-percent {
    background-color: #F6E5B3;
}

.time-percent {
    background-color: #B3E1F6;
}

.time-quantity {
    background-color: #F6BCB3;
}
</style>
